export default "__VITE_ASSET__BmgNlUHj__"